<ng-container *ngIf="modern; else classic">
  <!-- v2 and Admin v2: a compact dark pill. The status is an icon SHAPE (check, triangle, circled x,
       circled i) plus a hidden word for screen readers — never colour alone. -->
  <div class="jft-toast" *ngFor="let toast of toast.toasts" [attr.data-status]="toast.status" data-testid="jft-toast">
    <span class="jft-toast__icon" [ngSwitch]="toast.status" aria-hidden="true">
      <svg *ngSwitchCase="'success'" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>
      <svg *ngSwitchCase="'warning'" viewBox="0 0 24 24"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>
      <svg *ngSwitchCase="'danger'" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
      <svg *ngSwitchDefault viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
    </span>
    <span class="visually-hidden">{{ statusWord(toast.status) }}</span>
    <div class="jft-toast__body">
      <b class="jft-toast__title" *ngIf="toast.title">{{ toast.title }}</b>
      <span class="jft-toast__msg" [innerHTML]="toast.message"></span>
    </div>
    <button *ngIf="toast.action" type="button" class="jft-toast__action" (click)="executeAction(toast, $event)">
      {{ toast.action.label }}
    </button>
    <button type="button" class="jft-toast__close" (click)="remove(toast)" aria-label="Close">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    </button>
  </div>
</ng-container>

<ng-template #classic>
  <div class="toast-item" *ngFor="let toast of toast.toasts" [ngClass]="'toast-' + toast.status">
    <div class="toast-icon">
      <i class="fas" [ngClass]="{
        'fa-check-circle': toast.status === 'success',
        'fa-exclamation-circle': toast.status === 'danger',
        'fa-exclamation-triangle': toast.status === 'warning',
        'fa-info-circle': toast.status === 'info' || toast.status === 'primary'
      }"></i>
    </div>
    <div class="toast-content">
      <div class="toast-title" *ngIf="toast.title">{{ toast.title }}</div>
      <div class="toast-message" [innerHTML]="toast.message"></div>
    </div>
    <div class="toast-actions">
      <button *ngIf="toast.action" class="btn btn-sm btn-outline-primary me-2" (click)="executeAction(toast, $event)">
        {{ toast.action.label }}
      </button>
      <button class="toast-close" (click)="remove(toast)" aria-label="Close">
        &times;
      </button>
    </div>
  </div>
</ng-template>
